import { memo, useEffect } from "react";
import { useAtom } from 'jotai';
import { headerCenter_currentState_Atom, HeaderCenter_State } from "../store";
import { TerraDrawMode_Enum } from "~/components/MapDraw/TerraDrawUtil";

const ElementHeaderController = () => {
  const [headerCenter_CurrentState, setHeaderCenterCurrentProject] = useAtom(headerCenter_currentState_Atom);

  useEffect(() => {
    if (headerCenter_CurrentState === HeaderCenter_State.ELEMENT) {
      // do nothing
    } else { // if not ELEMENT
      if (window.draw && window.draw.enabled) {
        if (window.draw.getMode() !== TerraDrawMode_Enum.SELECT) {
          window.draw.setMode(TerraDrawMode_Enum.SELECT);
        }
      }
    }

  }, [headerCenter_CurrentState]);

  return <></>
}

export default memo(ElementHeaderController);